<template>
  <div>
    <Search></Search>
    <CommonTab :showIndexMenu="true">
      <CommonTabMenu slot="other-menu"></CommonTabMenu>
    </CommonTab>
    <IndexCategory>
      <li v-if="Object.keys(info).length > 0">
        {{ info.storeInfo.store_name }}
      </li>
    </IndexCategory>
    <!-- 商品信息展示 -->
    <ShowGoods :info="info"></ShowGoods>
    <!-- 商品详细展示 -->
    <ShowGoodsDetail :info="info"></ShowGoodsDetail>
  </div>
</template>

<script>
import CommonTab from "@/components/pc/nav/CommonTab";
import CommonTabMenu from "@components/pc/nav/CommonTabMenu";
import IndexCategory from "@/components/pc/nav/IndexCategory";
import Search from "@/components/pc/Search";
import ShowGoods from "@/components/pc/goodsDetail/ShowGoods";
import ShowGoodsDetail from "@/components/pc/goodsDetail/ShowGoodsDetail";
import { getProductDetail } from "@api/store";
export default {
  name: "GoodsDetail",
  data() {
    return {
      info: {},
      title: "",
      keywords: "",
      description: ""
    };
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        this.getProductInfo();
      }
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { name: "keywords", content: this.keywords },
        { name: "description", content: this.description }
      ]
    };
  },
  created() {
    this.getProductInfo();
  },
  methods: {
    getProductInfo() {
      const index = this.$route.params.id;
      getProductDetail(index).then(res => {
        this.info = res.data;

        this.title =
          this.info.storeInfo.general_name +
            "价格、说明书、副作用、禁忌症、功效 -元芝庄药店" ||
          this.$route.meta.title;
        this.keywords = this.info.storeInfo.seo_keywords;
        this.description = this.info.storeInfo.seo_description;
      });
    }
  },
  components: {
    Search,
    ShowGoods,
    ShowGoodsDetail,
    CommonTab,
    IndexCategory,
    CommonTabMenu
  }
};
</script>
<style lang="stylus" scoped>
.shop-item-path
  height 38px
  background-color: #f5f5f5
  line-height 38px
  color #2c2c2c
  .shop-nav-container
    margin 0px auto
    width 80%
</style>
